import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const StageErrorIcon = (t0)=>{
    const $ = c(6);
    const { width, height, color } = t0;
    let t1;
    if ($[0] !== color) {
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M8 16C3.584 16 0 12.416 0 8C0 3.584 3.584 0 8 0C12.416 0 16 3.584 16 8C16 12.416 12.416 16 8 16ZM8 8.94118C8.46782 8.94118 8.84706 8.56194 8.84706 8.09412V4.61177C8.84706 4.14395 8.46782 3.76471 8 3.76471C7.53219 3.76471 7.15295 4.14395 7.15295 4.61177V8.09412C7.15295 8.56194 7.53219 8.94118 8 8.94118ZM8 12.2353C8.5198 12.2353 8.94118 11.8139 8.94118 11.2941C8.94118 10.7743 8.5198 10.3529 8 10.3529C7.48021 10.3529 7.05883 10.7743 7.05883 11.2941C7.05883 11.8139 7.48021 12.2353 8 12.2353Z",
            fill: color
        });
        $[0] = color;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== height || $[3] !== t1 || $[4] !== width) {
        t2 = /*#__PURE__*/ jsx("svg", {
            width: width,
            height: height,
            viewBox: "0 0 16 16",
            children: t1
        });
        $[2] = height;
        $[3] = t1;
        $[4] = width;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
export { StageErrorIcon };
